import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/sections/Hero';
import { Problem } from './components/sections/Problem';
import { Framework } from './components/sections/Framework';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { Volumes } from './components/sections/Volumes';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { NotTextbook } from './components/sections/NotTextbook';
import { Audience } from './components/sections/Audience';
import { Author } from './components/sections/Author';
import { HowToStart } from './components/sections/HowToStart';
import { Testimonials } from './components/sections/Testimonials';
import { Guarantee } from './components/sections/Guarantee';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
import { Disclaimer } from './components/sections/Disclaimer';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-white font-sans text-ink" data-id="element-0" data-mp="3mjq45l4rr2xp">
      <MetaPixel data-id="element-1" data-mp="3rcsxbs5mwadd" />
      <Hero data-id="element-2" data-mp="3recctgjguhe3" />
      <main data-id="element-3" data-mp="5yjetptzbev">
        <Problem data-id="element-4" data-mp="5os92t1uy7l" />
        <Framework data-id="element-5" data-mp="680frswe88f" />
        <BeforeAfter data-id="element-6" data-mp="4n7u7q58zd7" />
        <Volumes data-id="element-7" data-mp="82kl3wchwbg" />
        <Bonuses data-id="element-8" data-mp="2zl3azit8d249" />
        <Offer data-id="element-9" data-mp="2zllen0i82im7" />
        <Testimonials data-id="element-10" data-mp="2zm4yimrfnh2v" />
        <NotTextbook data-id="element-11" data-mp="2zmo5j8fjol24" />
        <Audience data-id="element-12" data-mp="2zng1ikd20ksx" />
        <Author data-id="element-13" data-mp="33mf3bw3ho1g5" />
        <HowToStart data-id="element-14" data-mp="33lwxq8uxsavk" />
        <Guarantee data-id="element-15" data-mp="33ngee0ki8nxv" />
        <FAQ data-id="element-16" data-mp="33mykvbp88ntn" />
        <FinalCTA data-id="element-17" data-mp="33oi3h8ycvayl" />
      </main>
      <Disclaimer data-id="element-18" data-mp="38l8gfnev5qfs" />
      <FloatingCTA data-id="element-19" data-mp="38kqbm2e4y3w9" />
      <PurchasePopup data-id="element-20" data-mp="38k6wetfvdtlx" />
    </div>;
}